import { render } from "./widget-download-cargo.vue?vue&type=template&id=f15a0b76&scoped=true&ts=true"
import script from "./widget-download-cargo.vue?vue&type=script&lang=ts"
export * from "./widget-download-cargo.vue?vue&type=script&lang=ts"

import "./widget-download-cargo.vue?vue&type=style&index=0&id=f15a0b76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15a0b76"]])

export default __exports__